import { AnnotationType } from 'components/AnnotationProject/types'
import { CSSProperties } from 'react'
import { Annotation } from './Annotation'
const ymove = 6
const Labels = {
  konv: {
    material: (
      <>
        <span>Beschäftigungsmaterial</span>
        <br />
        Stroh, Raufutter oder anderes gleichwertiges Material
      </>
    ),
    area: (
      <>
        <span>
          0,3m<sup>2</sup>
        </span>
        <br />
        sonstige begehbare Fläche
      </>
    ),
    liege: (
      <>
        <span>
          0,6m<sup>2</sup>
        </span>
        <br />
        Liegefläche
      </>
    ),
  },
  bio: {
    material: (
      <>
        <span>Beschäftigungsmaterial</span>
        <br />
        langes Stroh
      </>
    ),
    auslauf: (
      <>
        <span>
          0,65m<sup>2</sup>
        </span>
        <br />
        Auslauf
      </>
    ),
    area: (
      <>
        <span>
          0,4m<sup>2</sup>
        </span>
        <br />
        restliche Fläche
      </>
    ),
    liege: (
      <>
        <span>
          0,6m<sup>2</sup>
        </span>
        <br />
        Liegefläche
      </>
    ),
  },
  eu: {
    area: (
      <>
        <span>
          0,75m<sup>2</sup>
        </span>
        <br />
        Stallfläche
      </>
    ),
    material: (
      <>
        <span>Beschäftigungsmaterial</span>
        <br />
        Stroh, Heu, Holz, Sägemehl, Pilzkompost, Torf oder eine Mischung dieser
        Materialien
      </>
    ),
  },
}

export const getAnnotations_Schwein = (
  colorMode: 'light' | 'dark' = 'light',
  width: number,
  standards: 'eu' | 'konventionell' | 'bio'
) => {
  const connectorStyle =
    colorMode === 'light'
      ? { stroke: '#000', strokeWidth: 0.5 }
      : { stroke: '#fff', strokeWidth: 0.5 }
  const connector: {
    type: 'straight' | 'curved'
    style: CSSProperties
    offset: number
  } = { type: 'straight', style: connectorStyle, offset: 0 }
  const S_Annotations_Konventionell: AnnotationType[] = [
    {
      left: 48,
      top: 50 + ymove,
      anchor: 'bottom',
      content: (
        <Annotation colorMode={colorMode} align='right'>
          {Labels.konv.material}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 52,
      top: 33 + ymove,
      anchor: 'top',
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 100 }}
        >
          {Labels.konv.area}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 58,
      top: 28 + ymove,

      anchor: 'top',
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: 120 }}>
          {Labels.konv.liege}
        </Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const S_Annotations_Konventionell_Medium: AnnotationType[] = [
    {
      left: 32,
      top: 52 + ymove,
      anchor: 'top',
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 180 }}
        >
          {Labels.konv.material}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 42,
      top: 45 + ymove,
      anchor: 'top',
      distance: 120,
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 100 }}
        >
          {Labels.konv.area}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 50,
      top: 41 + ymove,
      distance: 120,
      anchor: 'top',
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: 120 }}>
          {Labels.konv.liege}
        </Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const S_Annotations_Konventionell_Small: AnnotationType[] = [
    {
      left: 30,
      top: 53 + ymove,
      anchor: 'bottom',
      content: (
        <Annotation colorMode={colorMode}>{Labels.konv.material}</Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 40,
      top: 39 + ymove,
      anchor: 'top',
      distance: 150,
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 100 }}
        >
          {Labels.konv.area}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 50,
      top: 36 + ymove,
      distance: 120,
      anchor: 'top',
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: 120 }}>
          {Labels.konv.liege}
        </Annotation>
      ),
      connect: true,
      connector,
    },
  ]

  const S_Annotations_Bio: AnnotationType[] = [
    {
      left: 38,
      top: 56 + ymove,
      anchor: 'bottom',
      distance: 50,
      content: (
        <Annotation colorMode={colorMode}>{Labels.bio.material}</Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 55,
      top: 47 + ymove,
      anchor: 'right',
      distance:90,
      content: (
        <Annotation colorMode={colorMode} align='left'>
          {Labels.bio.auslauf}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 50,
      top: 34 + ymove,
      anchor: 'top',
      distance: 55,
      content: (
        <Annotation colorMode={colorMode} align='right'>
          {Labels.bio.area}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 67,
      top: 38 + ymove,
      anchor: 'right',
      distance: 80,
      content: (
        <Annotation colorMode={colorMode} align='left'>
          {Labels.bio.liege}
        </Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const S_Annotations_Bio_Medium: AnnotationType[] = [
    {
      left: 18,
      top: 57 + ymove,
      anchor: 'top',
      distance: 80,
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ maxWidth: 80 }}
        >
          {Labels.bio.material}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 28,
      top: 51 + ymove,
      anchor: 'top',
      distance: 190,
      content: (
        <Annotation colorMode={colorMode} align='right'>
          {Labels.bio.auslauf}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 41,
      top: 45 + ymove,
      anchor: 'top',
      distance: 130,
      content: (
        <Annotation colorMode={colorMode} align='right'>
          {Labels.bio.area}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 48,
      top: 42 + ymove,
      anchor: 'top',
      distance: 100,
      content: (
        <Annotation colorMode={colorMode} align='left'>
          {Labels.bio.liege}
        </Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const S_Annotations_Bio_Small: AnnotationType[] = [
    {
      left: 16,
      top: 57 + ymove,
      anchor: 'bottom',
      distance: 50,
      content: (
        <Annotation colorMode={colorMode}>{Labels.bio.material}</Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 24,
      top: 44 + ymove,
      anchor: 'top',
      distance: 150,
      content: (
        <Annotation colorMode={colorMode} align='right'>
          {Labels.bio.auslauf}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 39,
      top: 39 + ymove,
      anchor: 'top',
      distance: 140,
      content: (
        <Annotation colorMode={colorMode} align='left'>
          {Labels.bio.area}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 48,
      top: 37 + ymove,
      anchor: 'top',
      distance: 80,
      content: (
        <Annotation colorMode={colorMode} align='left'>
          {Labels.bio.liege}
        </Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  //
  const S_Annotations_EU: AnnotationType[] = [
    {
      left: 48,
      top: 50 + ymove,
      anchor: 'bottom',
      distance: 50,
      content: (
        <Annotation colorMode={colorMode} align='right'>
          {Labels.eu.material}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 54,
      top: 30 + ymove,
      anchor: 'top',
      distance: 60,
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: 120 }}>
          {Labels.eu.area}
        </Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const S_Annotations_EU_Medium: AnnotationType[] = [
    {
      left: 36,
      top: 50 + ymove,
      anchor: 'top',
      distance: 30,
      content: (
        <Annotation
          colorMode={colorMode}
          align='right'
          style={{ minWidth: 180 }}
        >
          {Labels.eu.material}
        </Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 51,
      top: 41 + ymove,
      anchor: 'top',
      distance: 80,
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: 120 }}>
          {Labels.eu.area}
        </Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  const S_Annotations_EU_Small: AnnotationType[] = [
    {
      left: 32,
      top: 53 + ymove,
      anchor: 'bottom',
      distance: 50,
      content: (
        <Annotation colorMode={colorMode}>{Labels.eu.material}</Annotation>
      ),
      connect: true,
      connector,
    },
    {
      left: 50,
      top: 36 + ymove,
      anchor: 'top',
      distance: 95,
      content: (
        <Annotation colorMode={colorMode} style={{ minWidth: 120 }}>
          {Labels.eu.area}
        </Annotation>
      ),
      connect: true,
      connector,
    },
  ]
  if (standards === 'eu')
    return width > 831
      ? S_Annotations_EU
      : width > 542
      ? S_Annotations_EU_Medium
      : S_Annotations_EU_Small
  if (standards === 'bio')
    return width > 831
      ? S_Annotations_Bio
      : width > 542
      ? S_Annotations_Bio_Medium
      : S_Annotations_Bio_Small
  if (standards === 'konventionell')
    return width > 831
      ? S_Annotations_Konventionell
      : width > 542
      ? S_Annotations_Konventionell_Medium
      : S_Annotations_Konventionell_Small
}
